import { combineReducers } from "redux";
import { TaskResult } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_TASK_RESULT_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<TaskResult> = {}, action: Action): Partial<TaskResult> {
  switch (action.type) {
    case getSuccessActionType(FETCH_TASK_RESULT_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_TASK_RESULT_REQUEST:
      return true;

    case getSuccessActionType(FETCH_TASK_RESULT_REQUEST):
    case getFailureActionType(FETCH_TASK_RESULT_REQUEST):
      return false;

    default:
      return state;
  }
}

export const taskResult = combineReducers({ item, isFetching });
